/* global $ */
import React, { useEffect } from 'react';
import { makeAPI } from '../../services/api';
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";         
import "datatables.net-dt/css/dataTables.dataTables.min.css"; 
// import { useGlobalState } from '../contexts/user';
const HOSTNAME = import.meta.env.VITE_API_URL;
const X_API_KEY = import.meta.env.VITE_X_API_KEY;
import coin from '../../assets/img/icons/coin.avif'
const EventLeaderboard = (props) => {
  // console.log(props);
  
//   const {user} = useGlobalState(); 
  let token = localStorage.getItem('token');
  let UserData = JSON.parse(localStorage.getItem('user'));
  let user_id = UserData?.user_id;
  // console.log("propsfull",props);
  // console.log("props",props.data[0].event_id);
  let EventId = props.data[0]?.event_id;
  let GameId = props.data[0]?.game_id;
  let GameName = props.data[0]?.event_title;


  useEffect(() => {
    // document.title = "Leaderboard - CGES.CLUB";
    $('#leaderboard-data').DataTable().destroy();
  
  loadWinningsData();
  }, []);
  async function loadWinningsData() {
    let inputObj = {};
    // inputObj.event_id = $("#leaderboard-list").val() || 1;
    inputObj.event_id = EventId || 1;
    inputObj.game_id = GameId || 1;
    // $("#leaderboard-list").val();

    $('#leaderboard-data').DataTable({

      "stateSave": false,
      "responsive": true,             
      "bInfo": false,
      "bDestroy": true,
      "bPaginate": false,
      "ordering": false,
      "serverSide": true,
      "bAutoWidth": false,
      "searching": false,
      "lengthMenu": [10, 20, 30, 50],
      "lengthChange": false,
      "orderable": false,
      "language": {
        "emptyTable": "No data available",
      },
      // "scrollX":true,
      "ajax": {
        url: `${HOSTNAME}/api/leaderboard`,
        headers: { "x-api-key": X_API_KEY  },
        // data: function (d) {
        //   return inputObj;
        // },
        data:{inputObj,user_id},
        type: 'POST',
        dataType: 'json',
        error: function (xhr, error, thrown) {

          let message = "Something went wrong.";

          switch (xhr.status) {
            case 429:
              message = "Too many requests. Please wait.";
              break;
            case 500:
              message = "Server error. Try again later.";
              break;
            case 403:
              message = "Access denied.";
              break;
            case 0:
              message = "Network error. Check internet.";
              break;
          }

          const table = $('#leaderboard-data').DataTable();

          // Update empty message dynamically
          table.settings()[0].oLanguage.sEmptyTable = message;

          // Clear table to trigger empty message
          table.clear().draw();
        }
      },
      

      //"../assets/img/coin.avif"
      "columns": columns_data(GameId),
      "columnDefs": GameId === 2 || GameId === 3 ?
                    [
                      { className: "dt-head-left dt-body-left", targets: '_all' },
                      { width: '10%', targets: 0 },
                      { width: '35%', targets: 1 },
                      { width: '10%', targets: 2 },
                      { width: '10%', targets: 3 },
                      { width: '10%', targets: 4 },
                      { width: '15%', targets: 5 },
                      { width: '10%', targets: 6 },
                    ]: [
                    {
                        className: "dt-head-left dt-body-left",
                        targets: '_all'
                    },
                    { width: '10%', targets: 0 },
                    { width: '45%', targets: 1 },
                    { width: '15%', targets: 2 },
                    { width: '15%', targets: 3 },
                    { width: '15%', targets: 4 },
                ],
      "initComplete": function (settings, json) {
        // formatDate(json)
        // console.log(json.data.crd_on, 'JSON DATA FROM SERVER');
        // countDownDate = new Date(json.end_time).getTime(); 
        // updateTimer(countDownDate)
        // Highlight the 10th row
        // $('#users tbody tr:eq(10)').removeClass('highlight');
        // $('#users tbody tr:eq(10)').addClass('highlight');
      },
      "rowCallback": function( row, data, dataIndex ) {
        if (data.user_id === UserData?.user_id) {
           $(row).find('td').css('background-color','#ff810e');
           $(row).find('td').css('color','#fff');
           $(row).find('td').css('font-weight','bold');
        }
       }
    });
  }
  return (
    <>


      <div className="container pd-top-40 table-responsive">
        <div className="row" >
          {/* <div className='col-2'></div> */}
          {/* <div className=' col-lg-12 col-md-12 col-12'>
            <div className="card default-form contact-form" style={{ backgroundColor: 'black', borderRadius: '20px' }}>
              <div className="card-body">
                <div className="row"> */}

                  {/* <div className="form-group col-xs-4 col-sm-8 col-md-5 col-lg-4 col-xl-5 col-7 mx-auto mx-md-0">
                    <select className="form-control fs-6 col-sm-5 bg-dark text-white border-secondary" id="leaderboard-list">
                      <option value="">Select Tournament</option>
                    </select>
                  </div> */}

                  {/* <div className="" style={{ textAlign: 'center' }}>
                    <h6 className='fs-2 fs-md-1 text-nowrap'>{GameName}</h6>
                  </div> */}

                  {/* <div className="col-4">
                    <div className="row">
                      <div className="col-5" style={{ textAlign: 'right' }}>
                        <p>Ends in:</p>
                      </div>
                      <div className="col-5" style={{ textAlign: 'left' }}>
                        <p id="timer">00:00:00:00</p>
                      </div>
                    </div>
                  </div> */}

                {/* </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="row" >
          {/* <div className='col-2'></div> */}
          <div className='col-xl-12 col-lg-12  col-md-12 col-12'>
            <table id="leaderboard-data" className="display table table-striped table-dark w-100">
              <thead>
                <tr>

                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
        <style>
          {
            `
            #leaderboard-data thead th {
                border-bottom: 1px solid #fff !important;
                border-top: 0 !important;
                border-left: 0 !important;
                border-right: 0 !important;
            }
            `
          }
        </style>

    </>
  )
}

// function formatDate(date) {
//   const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits
//   const month = date.toLocaleString('en-US', { month: 'short' }); // Short month name
//   const year = date.getFullYear();
//   return `${day} ${month} ${year}`;
// }


export default EventLeaderboard;

function columns_data (GameId){
  // console.log("game_id",GameId)
  let columns;
  if(GameId === 1){
   columns = [
      { data: 'rank', title: 'Rank', orderable: false },
        { data: 'player_name', title: 'Player Name', orderable: false ,
          render:function(data){
            if (data === "Guest") {
              let name = "--"
              return  name;
            }else {
              return data;
            }
          }
        },
        {
          data: 'points', title: 'Points', orderable: false,
          render: function (points) {
            if (points >= 0)
              return points;
            else if (points === "--") {
              let name = "--"
              return name;
            }
            else {
              return 0;
            }
          }

        },
        {
          data: 'reward', title: 'Reward <br/><small>(CGES coins)</small>', orderable: false,
          render: function (data) {
            let rewardPoints = data ? data : 0;
            return `<img src=${coin} loading="lazy" alt="CGES coin" width="15" height="15"> ${rewardPoints}` ;
          },
        },
        {
          data: 'reward', title: 'MVP Points', orderable: false,
          render: function (data) {
            let rewardPoints = data ? data : 0;
            return `${rewardPoints}`;
          },
        }
    ]
  }
  else if(GameId === 2 || GameId ===3){
    columns = [
      { data: 'rank', title: 'Rank', orderable: false },
        { data: 'player_name', title: 'Player Name', orderable: false,
          render:function(data){
            if (data === "Guest") {
              let name = "--"
              return  name;
            }else {
              return data;
            }
          }
         },
        { data: 'start_trophy', title: 'Initial Trophy', orderable: false,
          render:function(data){
            if(data === "--"){
              let name = "--"
              return name;
            }else {
              return data;
            }
          }
         },
        { data: 'end_trophy', title: 'Final Trophy', orderable: false ,
          render:function(data){
            if(data === "--"){
              let name = "--"
              return name;
            }
            else{
              return data;
            }
          }
        },
        {
          data: 'points', title: 'Points', orderable: false,
          render: function (points) {
            if (points >= 0)
              return points;
            else if (points === "--") {
              let name = "--"
              return name;
            }
            else {
              return 0;
            }
          }

        },
        {
          data: 'reward', title: 'Reward <br/><small>(CGES coins)</small>', orderable: false,
          render: function (data) {
            let rewardPoints = data ? data : 0;
            return `<img src=${coin} loading="lazy" alt="CGES coin" width="15" height="15"> ${rewardPoints} `;
          },
        },
        {
          data: 'reward', title: 'MVP Points', orderable: false,
          render: function (data) {
            let rewardPoints = data ? data : 0;
            return `${rewardPoints}`;
          },
        }
    ]
  }
  else{
        columns = [
        { data: 'rank', title: 'Rank', orderable: false },
        { data: 'player_name', title: 'Player Name', orderable: false },
        { data: 'points', title: ' Points', orderable: false },
        { data: 'reward', title: 'Reward <br/><small>(CGES coins)</small>', orderable: false,
          render: function (data) {
            let rewardPoints = data ? data : 0;
            return `<img src=${coin} loading="lazy" alt="CGES coin" width="15" height="15"> ${rewardPoints} `;
          },
         },
         { data: 'reward', title: 'MVP Points', orderable: false,
          render: function (data) {
            let rewardPoints = data ? data : 0;
            return `${rewardPoints}`;
          },
         },
        ]
  }
  return columns;
}